import * as React from "react";
import { useEffect, useState } from "react";
import "./add-item-modal.less";
import { useAppDispatch, useAppSelector } from "app.hook";
import { shallowEqual } from "react-redux";
import {
  addItemShoppingCart,
  selectModalAddCart,
  selectProductSelected,
  setModalAddItem,
} from "states/shopping-cart/shopping-cart.slice";
import { ShoppingCartItem } from "states/shopping-cart/shopping-cart.models";
import { IProductModel, IVariationAttributeModel, SelectGroupTypeEnum } from "states/menu/menu.models";
import { showError } from "states/global-value/global-value.slice";
import { AddItemModelViewDesktop } from "./add-item-modal-view-desktop";
import { isDesktop } from "react-device-detect";
import { AddItemModalMobile } from "./add-item-modal-mobile";
import _ from "lodash";
export interface IVariationAttribute{
  variationName: string;
  variationAttributes: IVariationAttributeModel[];
}
export function ModalAddCart() {
  const openModal = useAppSelector(selectModalAddCart, shallowEqual);
  const currentProductSelected = useAppSelector(
    selectProductSelected,
    shallowEqual
  );
  const dispatch = useAppDispatch();
  const [addProduct, setAddProduct] = useState<ShoppingCartItem>(
    {} as ShoppingCartItem
  );
  const [selectedVariations, setSelectedVariations] = useState<IVariationAttributeModel[]>([]);
  const handleCloseModal = () => {
    dispatch(setModalAddItem(false));
  };
  const handleDecreaseQuantity = () => {
    if (addProduct.quantity - 1 < 1) {
      return;
    }
    setAddProduct({ ...addProduct, quantity: addProduct.quantity - 1 });
  };
  const handleIncreaseQuantity = () => {
    setAddProduct({ ...addProduct, quantity: addProduct.quantity + 1 });
  };
  const handleSelectSingle = (
    modifiers: IProductModel[],
    modi: IProductModel
  ) => {
    if (
      addProduct.modifiers?.filter((m) => m.productId === modi.id)?.length > 0
    ) {
      return;
    }
    let temp = [...modifiers];
    addProduct.modifiers = addProduct.modifiers.filter(
      (m) => !temp.map((t) => t.id).includes(m.productId)
    );
    addProduct.modifiers.push({
      productId: modi.id,
      quantity: 1,
      price: modi.sellingPrice,
      image: modi.images.length > 0 ? modi.images[0] : "",
      modifiers: [],
      name: modi.name,
    });

    setAddProduct({ ...addProduct });
  };
  const handleSelectMultiple = (modi: IProductModel) => {
    if (
      addProduct.modifiers?.filter((m) => m.productId === modi.id)?.length > 0
    ) {
      addProduct.modifiers = addProduct.modifiers?.filter(
        (m) => m.productId !== modi.id
      );
    } else {
      addProduct.modifiers.push({
        productId: modi.id,
        quantity: 1,
        price: modi.sellingPrice,
        modifiers: [],
        name: modi.name,
        image: modi.images.length > 0 ? modi.images[0] : "",
      });
    }
    setAddProduct({ ...addProduct });
  };
  const handleAddProduct = () => {
    if(variationAttributes().length !== selectedVariations.length){
      dispatch(showError(`Please select ${variationAttributes().map(x=> x.variationName).join("&")}`));
      return;
    }
    var selectTypeSingle = currentProductSelected?.modifierGroups.find(
      (m) => m.selectType === SelectGroupTypeEnum.Single
    );
    if (
      selectTypeSingle !== undefined &&
      selectTypeSingle.modifiers.filter((m) =>
        addProduct.modifiers.map((m) => m.productId).includes(m.id)
      ).length === 0
    ) {
      dispatch(showError(`Please select ${selectTypeSingle.name}`));
      return;
    }
    dispatch(addItemShoppingCart(addProduct))
    .unwrap()
    .catch((err) => {
      dispatch(showError(err));
    });
  };

  const getProductWithVariation = (vAttrs: IVariationAttributeModel[]) =>{
    return _(currentProductSelected.product.variationProducts).chain().find(x=> _.differenceWith(vAttrs, x.variationAttributes, _.isEqual).length === 0).value();
  }
  const handleSelectVariation = (va: IVariationAttributeModel) =>{
    let variationsTemp = [...selectedVariations];
    if(variationsTemp.filter(x=> x.variationId === va.variationId).length > 0){
      variationsTemp = variationsTemp.filter(x=> x.variationId !== va.variationId);
    }
    variationsTemp.push(va);
    if(variationsTemp.length === variationAttributes().length){
      let currentProduct = getProductWithVariation(variationsTemp);
      addProduct.productId = currentProduct.id;
      addProduct.price = currentProduct.sellingPrice;
      addProduct.name = currentProduct.name;
      setSelectedVariations(variationsTemp);
    }
    setAddProduct({ ...addProduct });
  }
  const variationAttributes = () => {
    return _(currentProductSelected?.product?.variationProducts?.flatMap(x => x.variationAttributes)).chain()
      .uniqWith(_.isEqual).sortBy(x => x.variationId).groupBy(x => x.variationName).map((attrs, x) => ({ variationName: x, variationAttributes: attrs } as IVariationAttribute)).value();
  }
  const isSelectedVariation = (va:  IVariationAttributeModel)=>{
    let variationsTemp = [...selectedVariations];
    return  variationsTemp?.filter(x=> x.variationId === va.variationId && x.variationValueId === va.variationValueId).length > 0;
  }
  const isDisabledVariation = (va:  IVariationAttributeModel)  =>{
    let variationsTemp = [...selectedVariations];
    variationsTemp = variationsTemp.filter(x=> x.variationId !== va.variationId);
    variationsTemp.push(va);
    return !(_(currentProductSelected.product.variationProducts).chain().filter(x=> _.differenceWith(variationsTemp, x.variationAttributes, _.isEqual).length === 0).value().length > 0);
  }
  useEffect(() => {
    if (
      openModal &&
      currentProductSelected &&
      currentProductSelected.modifierGroups
    ) {
      const modifierRequired: ShoppingCartItem[] = [];
      currentProductSelected.modifierGroups.forEach((m) => {
        if (!m.isRequired) return;
        if (m.modifiers.length === 0) return;
        let modifier = m.modifiers[0];
        modifierRequired.push({
          productId: modifier.id,
          price: modifier.sellingPrice,
          quantity: 1,
          modifiers: [],
          name: modifier.name,
          image: modifier.images.length > 0 ? modifier.images[0] : "",
        });
      });
      let currentProduct =  currentProductSelected.product.variationProducts.length >  0 ? currentProductSelected.product.variationProducts[0]:  currentProductSelected.product;
      setAddProduct({
        price: currentProduct.sellingPrice,
        quantity: 1,
        image:
          currentProduct.images.length > 0
            ? currentProduct.images[0]
            : "",
        modifiers: modifierRequired,
        name:currentProduct.name,
        productId: currentProduct.id ,
      });
      setSelectedVariations(currentProduct.variationAttributes);
    }
  }, [openModal]);
  return (
    <>
      {!isDesktop ? (
        <AddItemModalMobile
          openModal={openModal}
          currentProductSelected={currentProductSelected}
          addProduct={addProduct}
          isDisabledVariation={isDisabledVariation}
          isSelectedVariation={isSelectedVariation}
          variationAttributes={variationAttributes()}
          handleSelectVariation={handleSelectVariation}
          handleCloseModal={handleCloseModal}
          handleDecreaseQuantity={handleDecreaseQuantity}
          handleIncreaseQuantity={handleIncreaseQuantity}
          handleSelectSingle={handleSelectSingle}
          handleSelectMultiple={handleSelectMultiple}
          handleAddProduct={handleAddProduct}
        />
      ) : (
        <AddItemModelViewDesktop
          openModal={openModal}
          currentProductSelected={currentProductSelected}
          addProduct={addProduct}
          isDisabledVariation={isDisabledVariation}
          isSelectedVariation={isSelectedVariation}
          variationAttributes={variationAttributes()}
          handleSelectVariation={handleSelectVariation}
          handleCloseModal={handleCloseModal}
          handleDecreaseQuantity={handleDecreaseQuantity}
          handleIncreaseQuantity={handleIncreaseQuantity}
          handleSelectSingle={handleSelectSingle}
          handleSelectMultiple={handleSelectMultiple}
          handleAddProduct={handleAddProduct}
        />
      )}
    </>
  );
}
